export default {
  title: 'Notas importantes',
  buttons: {
    add_note: 'Adicionar nota',
  },
};
